import { Loading } from 'vnetwork-ui'
import SubHeaders from '@/components/Headers/SubHeaders'
import Paper from '@/components/Paper'
import SubcontractAttachments from './Attachment'
import SubcontractInfoCard from './subcontract-info-card'
import { generatePathDatacentral, paths } from '@/utils/path'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import ProcessModules from '../../modules/SubcontractProcess'
import { getSubcontract } from '../../services'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import { ServicesCardsDisplay } from '@/modules/Contract/components/Detail'

const Detail = () => {
    const { contractID, subcontractID } = useParams()
    const { t } = useTranslation()

    const { data: subcontract, renderState } = useQueryWithHandler(
        {
            queryKey: [QUERY_KEYS.SUBCONTRACT, contractID, subcontractID],
            queryFn: () =>
                getSubcontract({
                    contractID: Number(contractID),
                    subcontractID: Number(subcontractID),
                }),
        },
        {
            loadingComponent: <Loading.Spin />,
        }
    )

    const stateComponent = renderState()
    if (stateComponent) return stateComponent
    return (
        <div className="space-y-2">
            <SubHeaders
                breadcrumbs={[
                    {
                        path: paths.customerContractList,
                        title: t('contract-list'),
                    },
                    {
                        path: generatePathDatacentral(
                            paths.customerContractDetail,
                            {
                                id: contractID,
                            }
                        ),
                        title: subcontract?.contract_number_id || '',
                    },
                    {
                        path: generatePathDatacentral(
                            paths.customerContractDetail,
                            {
                                id: contractID,
                            }
                        ),
                        title: t('subcontract-list'),
                    },
                    {
                        path: '',
                        title: subcontract?.subcontract_code || '',
                    },
                ]}
            />

            {subcontract && (
                <Paper className="p-4">
                    <SubcontractInfoCard
                        subcontract={subcontract}
                        contractID={contractID}
                    />
                </Paper>
            )}

            {(subcontract?.services?.length || 0) > 1 && (
                <ServicesCardsDisplay services={subcontract?.services!} />
            )}

            <SubcontractAttachments
                attachments={subcontract?.attachments}
                contractID={Number(contractID)}
                subcontractID={Number(subcontractID)}
            />
            <ProcessModules.List />
        </div>
    )
}
export default Detail
